export const initNavigation = () => {
  const menuToggle = document.querySelector('.js-menu-toggle');
  const headerMenu = document.querySelector('.js-header-menu');

  const getLocalAnchorTarget = (link) => {
    const linkUrl = new URL(link.href, window.location.href);
    const currentPath = window.location.pathname.replace(/\/index\.html$/, '/');
    const linkPath = linkUrl.pathname.replace(/\/index\.html$/, '/');

    if (!linkUrl.hash || linkUrl.origin !== window.location.origin || linkPath !== currentPath) {
      return null;
    }

    return document.getElementById(decodeURIComponent(linkUrl.hash.slice(1)));
  };

  const closeMenu = () => {
    if (!menuToggle || !headerMenu) {
      return;
    }

    headerMenu.classList.remove('is-open');
    menuToggle.classList.remove('is-active');
    menuToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('is-menu-open');
  };

  if (menuToggle && headerMenu) {
    menuToggle.addEventListener('click', () => {
      const isOpen = headerMenu.classList.toggle('is-open');

      menuToggle.classList.toggle('is-active', isOpen);
      menuToggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('is-menu-open', isOpen);
    });

    headerMenu.addEventListener('click', (event) => {
      if (!(event.target instanceof HTMLAnchorElement)) {
        return;
      }

      closeMenu();
    });
  }

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) {
      return;
    }

    const link = event.target.closest('a[href*="#"]');

    if (!link) {
      return;
    }

    const target = getLocalAnchorTarget(link);

    if (!target) {
      return;
    }

    event.preventDefault();
    closeMenu();
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    window.history.pushState(null, '', link.hash);
  });
};
